export default __webpack_public_path__ + "static/media/AlejosaurioRex.1f3e82ed.png";